import React, { useContext, useState, useEffect } from 'react';
import { Table, TableBody } from '@material-ui/core';
import classNames from 'classnames';
import _  from 'lodash';
import { useTranslation } from 'react-i18next';

import RacingDetailContext, { RacingDetailContextProps } from '../../Context/RacingDetail.context';
import './PickTable.scss';
import Icon from '../../../Icon/Icon';
import { RaceEvent } from '../../../../interfaces/RacingState';
import CompetitorsTableHead from '../CompetitorsTableHead/CompetitorsTableHead';
import CompetitorsTableRow from '../CompetitorsTableRow/CompetitorsTableRow';
import { toRoman } from 'src/utils/utils';

interface PickTableProps {
    crossEvent: RaceEvent
    index: number
}

export default function PickTable({ crossEvent, index }: PickTableProps) {
  const {
    selectedMarket,
    selectedHorsePosition,
    setSelectedHorsePosition,
    showCompetitors,
    setShowCompetitors
  } = useContext(RacingDetailContext);
  const { t } = useTranslation();
  const [crossEventState, togglecrossEventState] = useState(false);
  const [order, setOrder] = useState<RacingDetailContextProps['order']>('asc');
  const [orderBy, setOrderBy] = useState('startNo');

  useEffect(() => {
    togglecrossEventState(showCompetitors.show);
  }, [showCompetitors.show]);

  const toggle = () => {
    let newOpen = showCompetitors.open;

    if (!crossEventState) { //opening
      newOpen = newOpen + 1;
    } else if (crossEventState) { //closing
      newOpen = newOpen - 1;
    }

    if (newOpen === showCompetitors.total) {
      setShowCompetitors({
        ...showCompetitors,
        open: newOpen,
        show: true
      });
    } else if (newOpen === 0) {
      setShowCompetitors({
        ...showCompetitors,
        open: newOpen,
        show: false
      });
    } else {
      setShowCompetitors({
        ...showCompetitors,
        open: newOpen
      });
    }

    togglecrossEventState(!crossEventState);
  };

  const addingAllBets = () => {
    const newSelections = JSON.parse(JSON.stringify(selectedHorsePosition));

    if (crossEvent.competitors.length === selectedHorsePosition[index].length){
      newSelections[index] = [];
    } else {
      const horseNumbers = _.map(crossEvent.competitors, (competitor) => +competitor.progNo);
      newSelections[index] = horseNumbers;
    }

    setSelectedHorsePosition(newSelections);
  };

  const competitorsTable = () => {
    const markets = [{ name: 'pick' }];

    return (
      <Table size="small">
        <CompetitorsTableHead
          competitorsSize={ crossEvent.competitors.length }
          markets={ markets }
          leg={ `${ t('racingDetail.leg') } ${ index + 1 }` }
          index={ index.toString() }
          isPick
          addingAllBets={ addingAllBets }
          orderBy= { orderBy }
          setOrderBy={ setOrderBy }
          order={ order }
          setOrder= { setOrder }
          shouldWeight={ true }
          shouldJockey={ true }
        />
        <TableBody>
          {
            _.map(_.orderBy(crossEvent.competitors, orderBy, order), (competitor) => (
              <CompetitorsTableRow
                key={ competitor.horse ? competitor.horse.name + crossEvent.name : '' }
                competitor={ competitor }
                selectedMarketIndex={ 0 }
                selectedMarketName={ selectedMarket.name }
                crossEvent={ crossEvent }
                isPick
                leg= { index }
                shouldWeight={ true }
                shouldJockey={ true }
              />
            ))
          }
        </TableBody>
      </Table>
    );
  };

  const pickResultLength = _.filter(selectedHorsePosition, { position: `Leg ${ toRoman(index+1) }` }).length;

  return (
    <>
      <div
        className={
          classNames({
            'pick__pick-container': true,
            'pick__pick-container__selected': crossEventState
          })
        }
        onClick={ toggle }
      >
        <div
          className={
            classNames({
              'pick__pick-container__child': !crossEventState,
              'pick__pick-container__child-selected': crossEventState
            })
          }
        >
          <span>{ `${ t('racingDetail.leg') } ${ toRoman(index + 1) }` }</span>
          <span> - { crossEvent.name }</span>
          <span> { `${ t('racingDetail.race') } ${ crossEvent.number }` }</span>
          <span> { crossEvent.startTime }</span>
        </div>
        <div className="pick__conter-container">
          {
            (selectedHorsePosition && pickResultLength > 0) &&
              <span
                className={
                  classNames({
                    'pick__result' : true,
                    'pick__result--active': crossEventState
                  })
                }
              >
                { pickResultLength }
              </span>
          }
          <Icon
            icon="arrow"
            className={
              classNames({
                'pick__pick-container__down-arrow': crossEventState,
                'pick__pick-container__up-arrow': !crossEventState
              })
            }
          />
        </div>
      </div>
      {
        crossEventState &&
        <div className="pick">
          { competitorsTable() }
        </div>
      }
    </>
  );
}
